import { render, staticRenderFns } from "./subitem.vue?vue&type=template&id=59be417c"
import script from "./subitem.vue?vue&type=script&lang=js"
export * from "./subitem.vue?vue&type=script&lang=js"
import style0 from "./subitem.vue?vue&type=style&index=0&id=59be417c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports